import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import cns from 'classnames';
import { Row } from 'react-bootstrap';

import BaseDefaultFieldsForm from './BaseDefaultFieldsForm';

// Inputs
import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import BasicToggle from '../../../../../shared/components/formComponents/groups/BasicToggle';

class SectionItemSimpleDefaultFields extends BaseDefaultFieldsForm {
    static propTypes = {
        className: PropTypes.string,
        getFormValue: PropTypes.func.isRequired,
        changeFormValue: PropTypes.func.isRequired,
        localSectionItemMemberReference: PropTypes.string,
        sectionItemType: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        selectedSectionId: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { localSectionItemMemberReference, sectionItemType, className } = this.props;
        const disabledFields = this._getDisabled(localSectionItemMemberReference, sectionItemType);

        return (
            <div className={cns('col-md-12', className)}>
                <Row>
                    <Field
                        name={`${localSectionItemMemberReference}.name`}
                        label={'Name'}
                        className={'col-md-6'}
                        placeholder={'Section Item Name'}
                        disabled={disabledFields.name}
                        component={BasicText}
                    />
                    <Field
                        name={`${localSectionItemMemberReference}.isActive`}
                        label={'Active?'}
                        className={'col-md-3'}
                        disabled={disabledFields.isActive}
                        component={BasicToggle}
                        id={'section-item-simple-default-fields-toggle'}
                    />
                </Row>
            </div>
        );
    }
}

export default SectionItemSimpleDefaultFields;
